import useSendApiEvent from 'api/hooks/useSendApiEvent';
import { useCallback, useMemo } from 'react';
import { TrackPlaybackState, TrackPlaybackOptions } from './types';
import useMixpanelEventTracking from './useMixpanelEventTracking';
import useSponsoredEpisodeEventTracking from './useSponsoredEpisodeEventTracking';

export default function useTrackingProviderValue() {
  const mixpanelTrackingResult = useMixpanelEventTracking();
  const sponsoredEpisodeTrackingResult = useSponsoredEpisodeEventTracking();
  const { trackPlayback: trackMixpanelPlayback } = mixpanelTrackingResult;
  const { mutate: trackApiEvent } = useSendApiEvent();

  const trackPlayback = useCallback(
    (state: TrackPlaybackState, options: TrackPlaybackOptions) => {
      trackMixpanelPlayback(state, options);
      trackApiEvent({ eventType: 'playEpisode', ...options });
    },
    [trackApiEvent, trackMixpanelPlayback],
  );

  return useMemo(
    () => ({
      ...mixpanelTrackingResult,
      ...sponsoredEpisodeTrackingResult,
      trackPlayback,
    }),
    [mixpanelTrackingResult, sponsoredEpisodeTrackingResult, trackPlayback],
  );
}
